import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-header-search",
  "use": "app-icon-header-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-header-search\"><path d=\"M11 1.2c5.4 0 9.8 4.2 9.8 9.3 0 2.6-1.1 4.9-2.9 6.6l4.5 4.5c.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0l-4.6-4.6c-1.6 1.1-3.6 1.8-5.8 1.8-5.4 0-9.8-4.2-9.8-9.3S5.6 1.2 11 1.2zm0 1.7c-4.5 0-8.1 3.4-8.1 7.7s3.6 7.7 8.1 7.7 8.1-3.4 8.1-7.7-3.6-7.7-8.1-7.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol